import React, { Component, ReactNode } from "react";
import { detect } from "detect-browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import {
  Wrapper,
  Content,
  Text,
  Line,
  Link,
  ButtonWrapper,
} from "./internet-explorer-support-banner-app-styles";

interface IInternetExplorerSupportBannerAppState {
  ieMessageActive: boolean;
}

class InternetExplorerSupportBannerApp extends Component<
  unknown,
  IInternetExplorerSupportBannerAppState
> {
  state = {
    ieMessageActive: true,
  };

  closeIeMessage = (): void => {
    const { ieMessageActive } = this.state;

    this.setState({ ieMessageActive: !ieMessageActive });
  };

  render(): ReactNode {
    const isIE = detect().name === "ie";
    const { ieMessageActive } = this.state;

    if (isIE) {
      return (
        <Wrapper
          className={
            ieMessageActive ? "animated fadeInDown delay" : "animated fadeOutUp"
          }
        >
          <Content>
            <Text>
              <Line>
                Please note that <strong>Hiring Hub</strong> no longer supports{" "}
                <strong>Internet Explorer</strong>.
              </Line>
              <Line>
                We recommend upgrading to the latest{" "}
                <Link
                  href="https://www.microsoft.com/en-gb/windows/microsoft-edge/"
                  title="Microsoft Edge"
                  target="_blank"
                >
                  Microsoft Edge
                </Link>
                ,{" "}
                <Link
                  href="https://www.google.com/chrome/"
                  title="Google Chrome"
                  target="_blank"
                >
                  Google Chrome
                </Link>{" "}
                or{" "}
                <Link
                  href="https://www.mozilla.org/en-GB/firefox/new/"
                  title="Mozilla Firefox"
                  target="_blank"
                >
                  Mozilla Firefox
                </Link>
                .
              </Line>
            </Text>
            <ButtonWrapper onClick={this.closeIeMessage}>
              <FontAwesomeIcon icon={faTimes} />
            </ButtonWrapper>
          </Content>
        </Wrapper>
      );
    }
    return null;
  }
}

export default InternetExplorerSupportBannerApp;
